import React from 'react';
import { Container, Title, Text, Accordion, Paper, Divider } from '@mantine/core';

const DatenschutzErklaerung: React.FC = () => {
    return (
        <Container size="md" my="xl">
            <Title order={2} mb="lg">
                Datenschutzerklärung
            </Title>

            <Accordion chevronPosition="right" multiple>
                {/* Section 1 */}
                <Accordion.Item value="1. Datenschutz auf einen Blick">
                    <Paper shadow="xs" p="md" withBorder>
                        <Title order={4} mb="sm">
                            Allgemeine Hinweise
                        </Title>
                        <Text mb="sm">
                            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                        </Text>

                        <Divider my="sm" />

                        <Title order={5} mb="xs">
                            Datenerfassung auf dieser Website
                        </Title>
                        <Text mb="sm">
                            <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.
                        </Text>
                        <Text mb="sm">
                            <strong>Wie erfassen wir Ihre Daten?</strong><br />
                            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen – z. B. über ein Kontaktformular. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst (z. B. technische Daten wie Browser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
                        </Text>
                        <Text mb="sm">
                            <strong>Wofür nutzen wir Ihre Daten?</strong><br />
                            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Werden über die Website Verträge geschlossen, erfolgt die Verarbeitung auch für Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen.
                        </Text>
                        <Text>
                            <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
                            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten, sowie das Recht auf Berichtigung oder Löschung. Sie können eine erteilte Einwilligung jederzeit widerrufen und in bestimmten Fällen die Einschränkung der Verarbeitung verlangen. Zudem steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                        </Text>
                    </Paper>
                </Accordion.Item>

                {/* Section 2 */}
                <Accordion.Item value="2. Hosting">
                    <Paper shadow="xs" p="md" withBorder>
                        <Text mb="sm">
                            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                        </Text>
                        <Text mb="sm">
                            <strong>All-Inkl</strong><br />
                            Anbieter ist die ALL-INKL.COM - Neue Medien Münnich, Inh. René Münnich, Hauptstraße 68, 02742 Friedersdorf. Weitere Details entnehmen Sie der Datenschutzerklärung von All-Inkl:{" "}
                            <a href="https://all-inkl.com/datenschutzinformationen/" target="_blank" rel="noopener noreferrer">
                                https://all-inkl.com/datenschutzinformationen/
                            </a>
                        </Text>
                        <Text>
                            Die Verwendung von All-Inkl erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Sofern eine Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
                        </Text>
                        <Divider my="sm" />
                        <Text>
                            <strong>Auftragsverarbeitung</strong><br />
                            Wir haben einen Vertrag über Auftragsverarbeitung (AVV) geschlossen, der gewährleistet, dass personenbezogene Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet werden.
                        </Text>
                    </Paper>
                </Accordion.Item>

                {/* Section 3 */}
                <Accordion.Item value="3. Allgemeine Hinweise und Pflichtinformationen">
                    <Paper shadow="xs" p="md" withBorder>
                        <Text mb="sm">
                            <strong>Datenschutz</strong><br />
                            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung. Bitte beachten Sie, dass die Datenübertragung im Internet Sicherheitslücken aufweisen kann und ein lückenloser Schutz nicht möglich ist.
                        </Text>
                        <Text mb="sm">
                            <strong>Hinweis zur verantwortlichen Stelle</strong><br />
                            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                        </Text>
                        <Text mb="sm">
                            <strong>M. Tkocz</strong><br />
                            Telefon: +49 162 4307 132<br />
                            E-Mail: <a href="mailto:franchise@lagerfirst.de">franchise@lagerfirst.de</a><br />
                            Am Glüsig 1C, 39365 Harbke
                        </Text>
                        <Text mb="sm">
                            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
                        </Text>
                        <Divider my="sm" />
                        <Text mb="sm">
                            <strong>Speicherdauer</strong><br />
                            Sofern keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck der Verarbeitung entfällt. Bei einem berechtigten Löschersuchen oder Widerruf der Einwilligung werden Ihre Daten gelöscht, sofern keine anderen rechtlich zulässigen Gründe für die Speicherung bestehen.
                        </Text>
                        <Text mb="sm">
                            <strong>Rechtsgrundlagen</strong><br />
                            Die Verarbeitung erfolgt auf Grundlage der DSGVO (Art. 6 Abs. 1 lit. a, b, c, f bzw. Art. 9 Abs. 2 lit. a DSGVO). Weitere Details entnehmen Sie dieser Datenschutzerklärung.
                        </Text>
                        <Text mb="sm">
                            <strong>Empfänger von personenbezogenen Daten</strong><br />
                            Eine Weitergabe Ihrer Daten erfolgt nur, wenn dies zur Vertragserfüllung, aufgrund gesetzlicher Verpflichtungen, eines berechtigten Interesses oder einer anderen Rechtsgrundlage notwendig ist. Beim Einsatz von Auftragsverarbeitern geschieht dies auf Grundlage eines gültigen Vertrags.
                        </Text>
                        <Text mb="sm">
                            <strong>Widerruf und Widerspruch</strong><br />
                            Sie können Ihre Einwilligung zur Datenverarbeitung jederzeit widerrufen. Ferner haben Sie das Recht, unter bestimmten Umständen Widerspruch gegen die Verarbeitung Ihrer Daten einzulegen.
                        </Text>
                        <Text mb="sm">
                            <strong>Beschwerderecht</strong><br />
                            Im Falle von Verstößen gegen die DSGVO steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                        </Text>
                        <Text>
                            <strong>Recht auf Datenübertragbarkeit</strong><br />
                            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder zur Vertragserfüllung automatisiert verarbeiten, in einem gängigen, maschinenlesbaren Format zu erhalten.
                        </Text>
                        <Divider my="sm" />
                        <Text mb="sm">
                            <strong>Auskunft, Berichtigung und Löschung</strong><br />
                            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten sowie das Recht auf Berichtigung oder Löschung.
                        </Text>
                        <Text mb="sm">
                            <strong>Recht auf Einschränkung der Verarbeitung</strong><br />
                            Sie können die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen, z. B. während der Überprüfung der Richtigkeit der Daten.
                        </Text>
                        <Text>
                            <strong>SSL/TLS-Verschlüsselung</strong><br />
                            Diese Website nutzt aus Sicherheitsgründen SSL/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am Wechsel von „http://“ zu „https://“ sowie am Schloss-Symbol in der Browserzeile.
                        </Text>
                    </Paper>
                </Accordion.Item>

                {/* Section 4 */}
                <Accordion.Item value="4. Plugins und Tools">
                    <Paper shadow="xs" p="md" withBorder>
                        <Text mb="sm">
                            <strong>Google Fonts (lokales Hosting)</strong><br />
                            Diese Website nutzt Google Fonts zur einheitlichen Darstellung von Schriftarten. Die Fonts werden lokal gehostet, sodass keine direkte Verbindung zu den Servern von Google aufgebaut wird.
                        </Text>
                        <Text>
                            Weitere Informationen zu Google Fonts finden Sie unter{" "}
                            <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">
                                https://developers.google.com/fonts/faq
                            </a>{" "}
                            und in der Datenschutzerklärung von Google unter{" "}
                            <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">
                                https://policies.google.com/privacy?hl=de
                            </a>.
                        </Text>
                    </Paper>
                </Accordion.Item>
            </Accordion>
        </Container>
    );
};

export default DatenschutzErklaerung;
